// Auto generated file, do not manually modify!
// com.hotpads.admanagement.client.enums.AdManagementInvoiceDeliveryMethod

export enum AdManagementInvoiceDeliveryMethod {
  EMAIL = 'EMAIL',
  PRINT = 'PRINT',
  PRINT_AND_EMAIL = 'PRINT_AND_EMAIL',
  UPLOAD = 'UPLOAD',
  UPLOAD_COUPA = 'UPLOAD_COUPA',
  /**
   * @deprecated
   */
  UPLOAD_NEXUS = 'UPLOAD_NEXUS',
  UPLOAD_OPS_TECH = 'UPLOAD_OPS_TECH',
  UPLOAD_PAYMODE = 'UPLOAD_PAYMODE',
  UPLOAD_VENDOR_CAFE = 'UPLOAD_VENDOR_CAFE',
}

export const AdManagementInvoiceDeliveryMethod_values = [
  AdManagementInvoiceDeliveryMethod.EMAIL,
  AdManagementInvoiceDeliveryMethod.PRINT,
  AdManagementInvoiceDeliveryMethod.PRINT_AND_EMAIL,
  AdManagementInvoiceDeliveryMethod.UPLOAD,
  AdManagementInvoiceDeliveryMethod.UPLOAD_COUPA,
  AdManagementInvoiceDeliveryMethod.UPLOAD_NEXUS,
  AdManagementInvoiceDeliveryMethod.UPLOAD_OPS_TECH,
  AdManagementInvoiceDeliveryMethod.UPLOAD_PAYMODE,
  AdManagementInvoiceDeliveryMethod.UPLOAD_VENDOR_CAFE,
] as const;
